export default __webpack_public_path__ + "static/media/boygirl.99f5166f.png";